import {CredentialsType} from 'src/openapi/admin/models/CredentialsType';

import type {SalesforceCredentials} from 'src/openapi/admin/models/SalesforceCredentials';

type IsSalesforceTestReady = (credentials: SalesforceCredentials | null) => boolean;

export const isSalesforceTestReady: IsSalesforceTestReady = credentials => {
    if (!credentials) {
        return false;
    }

    if (credentials.credentialsType === CredentialsType.PASSWORD) {
        return !!credentials.passwordCredentials.login
            && (!!credentials.passwordCredentials.password || credentials.passwordCredentials.passwordNotEmpty);
    } else {
        return true;
    }
};
